import { Phone, MapPin, Clock, Bike } from "lucide-react";
import { BUSINESS } from "../data/business";
import { Reveal } from "./Reveal";
import { scrollTo } from "./Navbar";

export const Footer = () => (
  <footer className="relative pt-24 pb-10 overflow-hidden bg-coal text-bone" data-testid="footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <div className="grid md:grid-cols-4 gap-12 pb-20">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <img src="/images/logo.jpg" alt="Do jaja logo" className="w-14 h-14 rounded-full object-cover" />
              <div>
                <p className="font-display font-extrabold uppercase text-lg text-bone leading-none">Do jaja</p>
                <p className="font-mono-x text-[10px] uppercase tracking-[0.25em] text-cream mt-1.5">Since 2000 · Kragujevac</p>
              </div>
            </div>
            <p className="text-cream text-sm leading-relaxed max-w-sm">
              Roštilj koji Kragujevac ne zaboravlja. Sveže meso, ćumur i 20 priloga po izboru — svaki dan, do duboko u noć.
            </p>
            <div className="flex flex-wrap gap-3 mt-6">
              <a href={BUSINESS.glovo} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-ember text-white text-xs font-bold uppercase tracking-wide rounded-full px-5 py-2.5 hover:bg-emberglow transition-colors">
                <Bike className="w-3.5 h-3.5" /> Naruči preko Glovo-a
              </a>
              <a href={BUSINESS.wolt} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 border border-leaf text-leaf text-xs font-bold uppercase tracking-wide rounded-full px-5 py-2.5 hover:bg-leaf hover:text-white transition-colors">
                Naruči preko Wolt-a
              </a>
            </div>
          </div>
          <div>
            <p className="font-mono-x text-[10px] uppercase tracking-[0.25em] text-cream mb-5">Navigacija</p>
            <div className="flex flex-col gap-3">
              {[
                ["#rostilj", "Roštilj"],
                ["#meni", "Meni"],
                ["#prilozi", "Prilozi"],
                ["#price", "Priče gostiju"],
                ["#galerija", "Galerija"],
                ["#lokacija", "Lokacija"],
              ].map(([href, label]) => (
                <button
                  key={href}
                  onClick={() => scrollTo(href)}
                  className="text-left text-sm text-bone/80 hover:text-ember transition-colors duration-300 w-fit"
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
          <div>
            <p className="font-mono-x text-[10px] uppercase tracking-[0.25em] text-cream mb-5">Kontakt</p>
            <div className="flex flex-col gap-3 text-sm text-bone/80">
              {BUSINESS.phones.map((p) => (
                <a key={p.tel} data-testid={`footer-contact-phone-${p.tel}`} href={`tel:${p.tel}`} className="flex items-center gap-2.5 hover:text-ember transition-colors duration-300 w-fit">
                  <Phone className="w-4 h-4 text-ember" /> {p.label}
                </a>
              ))}
              <p className="flex items-center gap-2.5">
                <MapPin className="w-4 h-4 text-ember" /> {BUSINESS.address}
              </p>
              <p className="flex items-start gap-2.5">
                <Clock className="w-4 h-4 text-ember mt-0.5 shrink-0" />
                <span>
                  Pon–Čet <span className="text-leaf">08–03</span> · Pet–Sub <span className="text-leaf">08–05</span>
                  <br />
                  Ned <span className="text-leaf">14–00</span>
                </span>
              </p>
            </div>
          </div>
        </div>
      </Reveal>

      <div className="select-none pointer-events-none" aria-hidden="true">
        <p className="font-display font-black uppercase text-center leading-none text-stroke-chili-light text-[18vw] lg:text-[13rem] whitespace-nowrap">
          Do jaja
        </p>
      </div>

      <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-8 border-t border-white/10 mt-4">
        <p className="font-mono-x text-[10px] uppercase tracking-[0.2em] text-cream">
          © 2026 Do jaja · Kneza Miloša bb, Kragujevac
        </p>
        <p className="font-mono-x text-[10px] uppercase tracking-[0.2em] text-cream">
          Napravljeno na ćumuru
        </p>
      </div>
    </div>
  </footer>
);
